/**
 * ProductLoadingManager — унифицированный менеджер состояний загрузки списков товаров.
 *
 * Показывает Bootstrap-спиннер: если контейнер пуст — по центру, если товары есть —
 * оверлей поверх. Используется в каталоге и модалках.
 *
 * Пример:
 *   const lm = new ProductLoadingManager({
 *       containerSelector: '.product_list_catalog_outer',
 *       productsSelector:  '.js_products-list',
 *   });
 *   lm.showLoading();
 *   // ... fetch ...
 *   lm.updateProducts(html_products);
 */

const SPINNER_HTML = '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>';

class ProductLoadingManager {
    constructor(config) {
        if (!config || !config.containerSelector) {
            throw new Error('ProductLoadingManager: containerSelector is required');
        }

        this.containerSelector = config.containerSelector;
        this.productsSelector = config.productsSelector || null;

        this.container = document.querySelector(this.containerSelector);
        if (!this.container) {
            console.warn('ProductLoadingManager: Container not found:', this.containerSelector);
        }

        if (this.productsSelector) {
            this.productsContainer = document.querySelector(this.productsSelector);
        } else {
            this.productsContainer = this.container?.querySelector('.products-container, .js_products-list') || null;
        }

        if (!this.productsContainer) {
            console.warn('ProductLoadingManager: Products container not found');
            this.productsContainer = this.container;
        }
    }

    showLoading() {
        if (!this.container) return;
        this.hideLoading();

        if (this.productsContainer && this.productsContainer.children.length === 0) {
            // Первый рендер — спиннер по центру
            this.productsContainer.innerHTML = `<div class="text-center py-5">${SPINNER_HTML}</div>`;
        } else {
            // Есть товары — оверлей
            const overlay = document.createElement('div');
            overlay.className = 'loading-overlay';
            overlay.innerHTML = SPINNER_HTML;
            this.container.appendChild(overlay);
        }
    }

    hideLoading() {
        if (!this.container) return;
        this.container.querySelectorAll('.loading-overlay').forEach(el => el.remove());
    }

    updateProducts(html, append = false) {
        if (!this.productsContainer) return;
        this.hideLoading();
        if (append) {
            this.productsContainer.insertAdjacentHTML('beforeend', html);
        } else {
            this.productsContainer.innerHTML = html;
        }
    }

    clearProducts() {
        if (!this.productsContainer) return;
        this.productsContainer.innerHTML = '';
    }

    isLoading() {
        if (!this.container) return false;
        return (
            this.container.querySelector('.loading-overlay') !== null
            || (this.productsContainer?.querySelector('.spinner-border') !== null)
        );
    }
}

window.ProductLoadingManager = ProductLoadingManager;
